<template>
     <div>
        <Header />
        <TitlePage />
        <div class="faq">
            <b-container fluid="md">
                <div class="four-zero-four">
                    <IconAlertTriangle style="width: 87px;height: 75px;color: #DC3849;margin:20px;"/>
                    <h3 style="color:var(--projectPrimaryColor);font-size:34px;margin:20px;">{{$t('404.Couldn\'t find the listing you were looking for?')}}</h3>
                    <div class="margin:20px;">
                        <b-button class="btn-item" @click="clickNavigate('/')">{{$t('404.Go to homepage',{
                            affiliate:$root.affiliate,
                            site_name:$root.home_title
                        })}}</b-button>
                        <b-button class="btn-item" @click="clickNavigate('search')">{{$t('404.try new search')}}</b-button>
                    </div>
                </div>
            </b-container>
        </div>
         <Footer :adsFooter="adsFooter"/>
      </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from "@/components/ui/header";
import TitlePage from "@/components/ui/titlePage";
import Footer from "@/components/ui/footer";
import IconAlertTriangle from "@/components/icons/IconAlertTriangle";

export default {
    name: "FourZeroFour",
	components: {
		Header,
		TitlePage,
        Footer,
        IconAlertTriangle
	},
	data() {
		return {
			adsFooter: null,
		};
    },
    computed: {
		...mapGetters('UserController', ['isMobile'])
    },
    created(){
		let locationId = 9;
		if(this.isMobile){
			locationId=49;
		}
		this.getFooterAds(locationId);
	},
    methods:{
        clickNavigate(page) {
			if (window.location.pathname != this.$i18nRoute({ name: page })) {
				this.$router.push(this.$i18nRoute({ name: page }));
			}
        },
        ...mapActions("AdsController", [
			"GETADS_FOR_PUBLIC_WEBSITE",
			"CLICK_BANNERADS"
		]),
		getFooterAds(locationId){
			console.log("locationId",locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
				console.log("data",data)
			if (data) {
				this.adsFooter = data;
				this.$forceUpdate();
			}
			});
		},
	},
	destroyed(){
		console.log("destroyed search")
		this.adsFooter=null
	}

}
</script>
<style lang="scss">
.four-zero-four{
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    place-content: center;
    align-items: center;
    padding-right: 0;
    .btn-item {
        font-family: 'Prompt Semibold';
        font-size: 16px;
        @media (max-width: 992px) {
            font-size: 18px;
        }
        color: var(--projectPrimaryColor);;
        background: $white;
        border-color: var(--projectPrimaryColor);;
        border-radius: var(--borderRadius);
        min-width: 200px;
        margin: 20px;
    }
}
</style>